import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import BaseTable from "@/components_v2/Tables/BaseTable";
import AnalyticsCard from "@/features/certifications/analytics/components/AnalyticsCard";
import { CARD_SIZES } from "@/features/certifications/analytics/constants";
import { getModuleContentRows } from "@/features/certifications/analytics/utils";
import {
  ModuleContentRow,
  ModulesCardProps,
} from "@/features/certifications/analytics/types";

import "../styles.css";

const ModuleContentCard = ({ data, isLoading, isError }: ModulesCardProps) => {
  const { t } = useTranslation();
  const prefix = "certification.admin.analytics.content";
  const rows = useMemo(
    () => (data ? getModuleContentRows(t, data) : []),
    [data, t],
  );

  const columns = useMemo(
    () => [
      {
        key: "item",
        title: t(`${prefix}.columns.item`),
        render: (_: unknown, row: ModuleContentRow) => (
          <span className="flex flex-col">
            <span className={row.children ? "body-s-medium" : "body-s-regular"}>
              {row.title}
            </span>

            <span className="analytics-muted body-xs-regular">
              {row.subtitle}
            </span>
          </span>
        ),
      },
      {
        key: "activity",
        title: t(`${prefix}.columns.activity`),
        dataIndex: "activity",
      },
    ],
    [t],
  );

  return (
    <AnalyticsCard
      title={t(`${prefix}.title`)}
      info={t(`${prefix}.info`)}
      isLoading={isLoading}
      isError={isError}
      size={CARD_SIZES.FULL}
    >
      <BaseTable<ModuleContentRow>
        dataSource={rows}
        columns={columns}
        rowKey="key"
        pagination={false}
        scroll={{ x: "max-content" }}
        expandable={{ expandRowByClick: true }}
        locale={{ emptyText: t(`${prefix}.empty`) }}
      />
    </AnalyticsCard>
  );
};

export default ModuleContentCard;
